import React from "react";
import "./index.scss";
import {Icon} from "features/components/icon";
import {bool, func} from "prop-types";

export const FavoriteButton = (props) => {
    const {favorite, toggleFavorite} = props;
    return <div className="favorite-button" onClick={toggleFavorite}>
        <Icon>{favorite ? "heart-fill": "heart"}</Icon>
    </div>
}
FavoriteButton.propTypes = {
    favorite: bool.isRequired,
    toggleFavorite: func.isRequired
}